var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('VozIntroSection'),_c('VozEcosystemAndCompanyBrand'),_c('VozExpressionProfileSection'),_c('VozGuidelineFamilySection'),_c('VozGuidelineStrikingSection'),_c('VozGuidelineAdaptableSection'),_c('VozGuidelineTransparentSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }